import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useQuickFiltersContext } from 'modules/expenses/components/expenses/PageContents/QuickFiltersContext'
import { MyExpensesDataCollection } from 'modules/expenses/components/my_expenses/DataCollection/MyExpensesDataCollection'
import { MyExpensesDataTable } from 'modules/expenses/components/my_expenses/Datatable'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'
import expensesCategoriesContractsTaxonomies from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

import { useMyExpenses } from './MyExpensesContext'

const MyExpensesListTab = () => {
  const { employee } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const [availableCategories, setAvailableCategories] = useState<string[] | undefined>(undefined)
  const [currentPeriodOpen, setCurrentPeriodOpen] = useState<boolean>(false)
  const { filters } = useQuickFiltersContext()
  const { company } = useCurrentSession()
  const { dateFilters } = usePageDateFilters()
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useMyExpenses()

  const {
    categories,
    subcategories,
    canSeeTransactions,
    hasExpensesReportOnBehalfFeature,
    loading,
  } = useExpensesListPage({ companyId: company.id, skipProjectsQuery: true })

  const { loading: loadingPayroll } = useAsyncData(
    () =>
      Promise.all([
        expensesCategoriesContractsTaxonomies.existingTaxonomies().then((categories) => {
          setAvailableCategories(categories)
        }),
        policyPeriods.isCurrentOpen().then(({ open_to_supplements }) => {
          setCurrentPeriodOpen(open_to_supplements)
        }),
      ]),
    []
  )

  if (!employee) {
    navigate(navigation.myExpenses.list.expenses.fullPath())
    return null
  }

  if (loading || loadingPayroll) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return dataCollectionEnabled ? (
    <MyExpensesDataCollection companyId={company.id} employeeId={employee.id} />
  ) : (
    <MyExpensesDataTable
      companyId={company.id}
      key={JSON.stringify(filters)} //re-mount the datatable if expensable search params change
      subcategories={subcategories}
      currentPayrollPeriodOpen={currentPeriodOpen}
      availablePayrollCategories={availableCategories || []}
      categories={categories}
      employeeIds={[employee?.id]}
      back={{ href: navigation.myExpenses.list.expenses.fullPath() }}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      canSeeTransactions={canSeeTransactions}
      dateFilters={dateFilters}
    />
  )
}

export default MyExpensesListTab
